<template>
  <div class="row text-center success-component">
    <div class="col-12">
      <svg-viewer
        class="ml-auto mr-auto"
        :src="require('../assets/images/banner/09/09-cross-error.svg')"
        height="130px"
        width="200px"
      >
      </svg-viewer>
    </div>
    <div class="col-12 mb-2">
      <span class="success-title">Ops!</span>
    </div>
    <div class="col-12 mb-3">
      <span class="success-desc"
        >L’invio all’indirizzo <strong>{{ email }}</strong> non è andato a buon
        fine</span
      >
    </div>
    <div class="col-12 mb-5">
      <b-button variant="link red-link text-center" @click="back()"
        ><u>Invia di nuovo</u></b-button
      >
    </div>
    <div class="col-12 mb-3">
      <b-button variant="white long" @click="goHome()"
        >Torna alla Homepage</b-button
      >
    </div>
  </div>
</template>

<script>
import router from "../router";
import { resetState } from "../helpers/store.utils";
import { goBack } from "../helpers/router.utils";
export default {
  name: "SavingError",
  props: {
    email: String
  },
  methods: {
    goHome() {
      resetState();
      router.push("/");
    },
    goToSimulation() {
      router.push("/");
    },
    back() {
      goBack();
    }
  }
};
</script>

<style scoped></style>
